import { DelayedSpinner } from "@digipost/dds-spinner-react";
import { useEffect } from "react";

import { useEntrypointContext } from "../EntrypointContext";

export const CompletePersonLogin: React.FC = () => {
  const entrypoint = useEntrypointContext();

  useEffect(() => {
    if (entrypoint) {
      window.location.href = "/postkasse/?login-successful=true";
    }
  }, [entrypoint]);

  return <DelayedSpinner />;
};
